export default {
    input: "# This is a header\n\nAnd this is a paragraph"
};
